import React, { Component } from 'react';
import auth from '../../components/user/services/Auth';
import LoadingSpinner from '../../components/loading-spinner/LoadingSpinner';
import UrlParamsUtil from "../../services/util/UrlParamsUtil";
import { getLanguage } from '../../store/rootReducer';
import { connect } from 'react-redux';

class PassUserName extends Component {

  handlePassUserName = () => {
    let parsedResult = UrlParamsUtil.getQueryParamsFromUrl(this.props);
    if (parsedResult.username) {
      auth.passUserNameToCas(parsedResult.username).then(() => {
        auth.login(this.props.language);
      })
    }
  };

  componentDidMount() {
    this.handlePassUserName();
  }

  render() {
    return (
        <LoadingSpinner />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    language: getLanguage(state)
  }
};

export default connect(mapStateToProps)(PassUserName);